// @flow strict

import * as React from 'react';
import PageContentBlock from '../../internal/PageContentBlock';
import { Link } from '../../internal/Button';
import styles from './styles.scss';
import type { BlockRichText } from '../../internal/types';
import FormattedContent from '../../internal/FormattedContent';

type PropTypes = {|
  errorCode: number,
  errorDescription: string,
  errorActionText: BlockRichText,
  ctaText?: string,
  ctaHref?: string,
|};

export default (props: PropTypes) => {
  return (
    <PageContentBlock layout="Thin">
      <div className={styles.page}>
        <h1 className={styles.title}>{props.errorCode}</h1>
        <p className={styles.subtitle}>{props.errorDescription}</p>
        <FormattedContent className={styles.text}>{props.errorActionText}</FormattedContent>
        {props.ctaText && props.ctaHref && (
          <Link href={props.ctaHref} variant="GhostInverse">
            {props.ctaText}
          </Link>
        )}
      </div>
    </PageContentBlock>
  );
};
